module.exports = __webpack_public_path__ + "img/bldc_hall2.d7a57cba.png";